export default __webpack_public_path__ + "static/media/IF_MyLeadershipStrengths_StrengthDesc_10.957409b9.jpg";